/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.neopixel = {};

  /**
   *
   * @param {*} hexadecimal
   * @returns
   */
  function hexToRed(hexadecimal) {
    return parseInt(cutHex(hexadecimal).substring(0, 2), 16);
  }

  /**
   *
   * @param {*} hexadecimal
   * @returns
   */
  function hexToGreen(hexadecimal) {
    return parseInt(cutHex(hexadecimal).substring(2, 4), 16);
  }

  /**
   *
   * @param {*} hexadecimal
   * @returns
   */
  function hexToBlue(hexadecimal) {
    return parseInt(cutHex(hexadecimal).substring(4, 6), 16);
  }

  /**
   *
   * @param {*} hexadecimal
   * @returns
   */
  function cutHex(hexadecimal) {
    return "#" == hexadecimal.charAt(1)
      ? hexadecimal.substring(2, 8)
      : hexadecimal;
  }

  /**
   *
   * @returns
   */
  Blockly.Arduino.neopixel_init = function () {
    Blockly.Arduino.includes_.push(libraries.adafruit_neopixel);

    const rgbMode = this.getFieldValue("RGBMODE");
    const freq = this.getFieldValue("FREQ");
    const pin = this.getFieldValue("PIN");

    const led_qty = Blockly.Arduino.valueToCode(
      this,
      "LEDCOUNT",
      Blockly.Arduino.ORDER_ATOMIC
    );

    Blockly.Arduino.definitions_.define_neopixel =
      "#include <Adafruit_NeoPixel.h>\n";

    Blockly.Arduino.definitions_.var_neopixel =
      "Adafruit_NeoPixel neo_pixel = Adafruit_NeoPixel(" +
      (led_qty + ", " + pin + ", " + rgbMode + " + " + freq + ");\n");

    Blockly.Arduino.setups_.setup_neopixel = "  neo_pixel.begin();\n";

    return "";
  };

  Blockly.Arduino.neopixel_clear = function () {
    return "neo_pixel.clear();\n";
  };

  Blockly.Arduino.neopixel_setled = function () {
    let code = "";
    const led_number = Blockly.Arduino.valueToCode(
      this,
      "LEDNUMBER",
      Blockly.Arduino.ORDER_ATOMIC
    );

    const red = Blockly.Arduino.valueToCode(
      this,
      "R",
      Blockly.Arduino.ORDER_ATOMIC
    );

    const green = Blockly.Arduino.valueToCode(
      this,
      "G",
      Blockly.Arduino.ORDER_ATOMIC
    );

    const blue = Blockly.Arduino.valueToCode(
      this,
      "B",
      Blockly.Arduino.ORDER_ATOMIC
    );

    code =
      "neo_pixel.setPixelColor(" +
      led_number +
      (", neo_pixel.Color(" + red + "," + green + "," + blue + "));\n");

    return code;
  };

  Blockly.Arduino.neopixel_setled_colour_picker = function () {
    let code = "";
    const led_number = Blockly.Arduino.valueToCode(
      this,
      "LEDNUMBER",
      Blockly.Arduino.ORDER_ATOMIC
    );

    const colour = Blockly.Arduino.valueToCode(
      this,
      "COLOUR",
      Blockly.Arduino.ORDER_ATOMIC
    );

    const red = hexToRed(colour);
    const green = hexToGreen(colour);
    const blue = hexToBlue(colour);

    code =
      "neo_pixel.setPixelColor(" +
      led_number +
      (", neo_pixel.Color(" + red + ", " + green + ", " + blue + "));\n");

    return code;
  };

  Blockly.Arduino.neopixel_show = function () {
    return "neo_pixel.show();\n";
  };

  function fnc_rainbow() {
    Blockly.Arduino.definitions_fnc_.fnc_rainbow =
      "void fnc_rainbow(int wait) {\n" +
      "  for(long firstPixelHue = 0; firstPixelHue < 5*65536; firstPixelHue += 256) {\n" +
      "    for(int i=0; i < neo_pixel.numPixels(); i++) {\n" +
      "      int pixelHue = firstPixelHue + (i * 65536L / neo_pixel.numPixels());\n" +
      "      neo_pixel.setPixelColor(i, neo_pixel.gamma32(neo_pixel.ColorHSV(pixelHue)));\n" +
      "    }\n" +
      "    neo_pixel.show();\n" +
      "    delay(wait);\n" +
      "  }\n" +
      "}\n";
  };

  function fnc_theater() {
    Blockly.Arduino.definitions_fnc_.fnc_theater =
      "void fnc_theater(int wait) {\n" +
      "  int firstPixelHue = 0;\n" +
      "  for(int a = 0; a < 30; a++) {\n" +
      "    for(int b = 0; b < 3; b++) {\n" +
      "      neo_pixel.clear();\n" +
      "      for(int c = b; c < neo_pixel.numPixels(); c += 3) {\n" +
      "        int      hue   = firstPixelHue + c * 65536L / neo_pixel.numPixels();\n" +
      "        uint32_t color = neo_pixel.gamma32(neo_pixel.ColorHSV(hue));\n" +
      "        neo_pixel.setPixelColor(c, color);\n" +
      "      }\n" +
      "      neo_pixel.show();\n" +
      "      delay(wait);\n" +
      "      firstPixelHue += 65536 / 90;\n" +
      "    }\n" +
      "  }\n" +
      "}\n";
  };

  function fnc_wipe() {
    Blockly.Arduino.definitions_fnc_.fnc_wipe =
      "void fnc_wipe(uint32_t c, uint8_t wait) {\n" +
      "  for(uint16_t i=0; i<neo_pixel.numPixels(); i++) {\n" +
      "    neo_pixel.setPixelColor(i, c);\n" +
      "    neo_pixel.show();\n" +
      "    delay(wait);\n" +
      "  }\n" +
      "}\n";
  };

  function fnc_chase() {
    Blockly.Arduino.definitions_fnc_.fnc_chase =
      "void fnc_chase(uint32_t c, uint8_t wait) {\n" +
      "  for (int j = 0; j < 10; j++) {\n" +
      "    for (int q = 0; q < 3; q++) {\n" +
      "      for (uint16_t i = 0; i < neo_pixel.numPixels(); i = i + 3) {\n" +
      "        neo_pixel.setPixelColor(i + q, c);\n" +
      "      }\n" +
      "      neo_pixel.show();\n" +
      "      delay(wait);\n" +
      "      for (uint16_t i = 0; i < neo_pixel.numPixels(); i = i + 3) {\n" +
      "        neo_pixel.setPixelColor(i + q, 0);\n" +
      "      }\n" +
      "    }\n" +
      "  }\n" +
      "}\n";
  };

  Blockly.Arduino.neopixel_examples = function () {
    Blockly.Arduino.includes_.push(libraries.adafruit_neopixel);
    const example = this.getFieldValue("EXAMPLE");
    // const speed = Blockly.Arduino.valueToCode(this, "SPEED", Blockly.Arduino.ORDER_ATOMIC) || 20;
    const speed = this.getFieldValue("SPEED_NUMBER") || 20;

    const red   = Blockly.Arduino.valueToCode(this, "R", Blockly.Arduino.ORDER_ATOMIC) || 0;
    const green = Blockly.Arduino.valueToCode(this, "G", Blockly.Arduino.ORDER_ATOMIC) || 0;
    const blue  = Blockly.Arduino.valueToCode(this, "B", Blockly.Arduino.ORDER_ATOMIC) || 0;

    let code = "";
    if (example == "NEO_EXAMPLE_RAINBOW") {
      fnc_rainbow();
      code = "fnc_rainbow(" + speed + ");\n";
    } else if (example == "NEO_EXAMPLE_THEATER") {
      fnc_theater();
      code = "fnc_theater(" + speed + ");\n";
    } else if (example == "NEO_EXAMPLE_WIPE") {
      fnc_wipe();
      code = "fnc_wipe(neo_pixel.Color(" + red + ", " + green + ", " + blue + "), " + speed + ");\n";
    } else if (example == "NEO_EXAMPLE_CHASE") {
      fnc_chase();
      code = "fnc_chase(neo_pixel.Color(" + red + ", " + green + ", " + blue + "), " + speed + ");\n";
    }
    return code;
  };

  Blockly.Arduino.neopixel_setbrightness = function () {
    const brightness = Blockly.Arduino.valueToCode(
      this,
      "BRIGHTNESS",
      Blockly.Arduino.ORDER_ATOMIC
    ) || 50;
    return "neo_pixel.setBrightness(" + brightness + ");\n";
  };

}